const AXIS_TICK_COUNT = 5;

export function getAxisLabels(minValue: number, maxValue: number): number[] {
    if (!(maxValue > minValue)) {
        const single = Math.round(Math.max(maxValue, 0));
        return [single + 1, single];
    }

    const step = (maxValue - minValue) / (AXIS_TICK_COUNT - 1);
    return Array.from(
        { length: AXIS_TICK_COUNT },
        (_, index) => Math.round(maxValue - index * step),
    );
}
